export async function GetVersionTag() {
	const manifestPath = process.env.REACT_APP_MANIFEST_URL as string;

	const response = await fetch(manifestPath)
		.then(res => res.text())
		.catch((err) => console.log("The request went bad, status: " + err.toString())) as string;
	var parser = new DOMParser();
	var xmlDoc = parser.parseFromString(response, 'text/xml');
	return xmlDoc.getElementsByTagName("Version")[0].childNodes[0].nodeValue as string;
}